import { FuseNavigation } from '@fuse/types';
import { NAVIGAZIONE } from 'app/main/utils/costanti';

export const navigation: FuseNavigation[] = [
  {
    id: 'servizi',
    title: 'Servizi',
    type: 'group',
    icon: '',
    children: [],
    visibile: true,
    visibilePerNonSoci: true,
    visibilePerTerzi: true,
    visibilePerFondazione: true
  },
  {
    id: 'ricerca-corsi',
    title: 'Ricerca corsi',
    type: 'item',
    icon: 'search',
    url: '/ricerca-corsi',
    visibilePerTerzi: true
  },
  {
    id: 'home',
    title: 'Home',
    type: 'item',
    icon: 'home',
    url: '/welcome',
    visibile: true,
    visibilePerNonSoci: true,
    trackerIndex: NAVIGAZIONE.Home
  },
  {
    id: 'dls',
    title: 'Digital Lex Salus',
    type: 'collapsable',
    icon: 'description',
    visibile: true,
    badge: {
      title: 'Novità',
      bg: 'var(--mat-sys-error)',
      fg: 'var(--mat-sys-on-error)'
    },
    visibilePerNonSoci: true,
    visibilePerTerzi: true,
    visibilePerFondazione: true,
    dlsMenuPermission: 'visualizza',
    children: [
      {
        id: 'dls-compilazioni',
        title: 'Compilazioni',
        type: 'item',
        url: '/dls/compilazioni',
        dlsMenuPermission: 'compilazioni'
      },
      {
        id: 'dls-contatta-consulente',
        title: 'Quesiti al consulente',
        type: 'item',
        url: '/dls/contatta-consulente',
        dlsMenuPermission: 'contatta_consulente'
      },
      {
        id: 'dls-contenuti',
        title: 'Contenuti & Media',
        type: 'item',
        url: '/dls/contenuti',
        dlsMenuPermission: 'contenuti'
      },
      {
        id: 'dls-contenuti',
        title: 'Gestione Contenuti & Media',
        type: 'item',
        url: '/dls/contenuto-privacy',
        dlsMenuPermission: 'gestione_contenuti'
      },
      {
        id: 'dls-webinar',
        title: 'Webinar',
        type: 'item',
        url: '/dls/webinar',
        dlsMenuPermission: 'webinar'
      },
      {
        id: 'dls-community',
        title: 'Community',
        type: 'item',
        url: '/dls/community',
        dlsMenuPermission: 'forum'
      },
      {
        id: 'dls-abbonamento',
        title: 'Abbonamento',
        type: 'item',
        url: '/dls/abbonamento',
        dlsMenuPermission: 'abbonamento'
      },
      {
        id: 'dls-statistiche',
        title: 'Statistiche',
        type: 'item',
        url: '/dls/statistiche',
        dlsMenuPermission: 'statistiche'
      },
      {
        id: 'dls-storico-fatture',
        title: 'Storico fatture',
        type: 'item',
        url: '/dls/storico-fatture',
        dlsMenuPermission: 'storico_fatture'
      }
    ]
  },
  // {
  //   id: 'streaming',
  //   title: 'Diretta Expodental',
  //   translate: '',
  //   type: 'item',
  //   icon: 'play_circle_outline',
  //   url: '/diretta',
  //   visibile: true
  // },
  {
    id: 'corsi',
    title: 'Corsi',
    type: 'collapsable',
    icon: 'school',
    trackerIndex: NAVIGAZIONE.Corsi,
    children: [
      {
        id: 'profilo',
        title: 'Il Mio Profilo Corsi',
        type: 'item',
        icon: '',
        url: '/academy/profilo'
      },
      {
        id: 'corsi-ecm',
        title: 'Corsi FAD',
        type: 'item',
        icon: '',
        url: 'academy/corsi-fad'
      },
      {
        id: 'corsi-ecm',
        title: 'Corsi FAD Sincroni (Webinar)',
        type: 'item',
        icon: '',
        url: 'academy/corsi-fad-sincroni'
      },
      {
        id: 'corsi-residenziali',
        title: 'Corsi Residenziali (in presenza)',
        type: 'item',
        icon: '',
        url: '/academy/corsi-residenziali'
      },
      // {
      //   id: 'corsi-blended',
      //   title: 'Corsi Blended',
      //   translate: '',
      //   type: 'item',
      //   icon: '',
      //   url: '/academy/corsi-blended'
      // },
      {
        id: 'corsi-sicurezza',
        title: 'Corsi Lavoratori',
        type: 'item',
        icon: '',
        url: 'academy/corsi-lavoratori'
      },
      {
        id: 'comitato-scientifico',
        title: 'Comitato scientifico',
        type: 'item',
        icon: '',
        url: 'academy/comitato-scientifico'
      }
      // {
      //   id: 'corsi-sicurezza',
      //   title: ' Sicurezza lavoratori e RLS',
      //   translate: '',
      //   type: 'item',
      //   icon: '',
      //   url: '/academy/corsi-sicurezza'
      // }
      // {
      //   id: 'profilo',
      //   title: 'Il tuo Profilo Corsi',
      //   translate: '',
      //   type: 'item',
      //   icon: '',
      //   url: '/academy/profilo'
      // },
      // {
      //   id: 'corsi-ecm',
      //   title: 'Corsi FAD',
      //   translate: '',
      //   type: 'item',
      //   icon: '',
      //   url: 'academy/corsi-fad'
      // },
      // {
      //   id: 'corsi-residenziali',
      //   title: 'Corsi Residenziali',
      //   translate: '',
      //   type: 'item',
      //   icon: '',
      //   url: '/academy/corsi-residenziali'
      // }
      // {
      //   id: 'corsi-blended',
      //   title: 'Corsi Blended (RSPP - 81/08)',
      //   translate: '',
      //   type: 'item',
      //   icon: '',
      //   url: '/academy/corsi-blended'
      // },
    ],
    visibile: true,
    visibilePerNonSoci: true
  },
  // {
  //   id: 'gdpr',
  //   title: 'GDPR',
  //   translate: '',
  //   type: 'collapsable',
  //   icon: 'security',
  //   visibile: true,
  //   visibilePerNonSoci: true,
  //   trackerIndex: NAVIGAZIONE.GDPR,
  //   children: [
  //     {
  //       id: 'gdpr-corso',
  //       title: 'Corso',
  //       translate: '',
  //       type: 'item',
  //       url: '/gdpr-ecm/corso'
  //     },
  //     {
  //       id: 'gdpr-moduli',
  //       title: 'Modulistica',
  //       translate: '',
  //       type: 'item',
  //       url: '/gdpr-ecm/modulistica'
  //     }
  //   ]
  // },
  {
    id: 'gestione_contabilita',
    title: 'Fattura Elettronica e STS',
    type: 'item',
    icon: 'dvr',
    url: '/gestione-contabilita',
    trackerIndex: NAVIGAZIONE.FatturazioneElettronica,
    visibile: true
  },
  {
    id: 'il-mio-studio',
    title: 'Il mio studio',
    type: 'collapsable',
    icon: 'business_center',
    filtraFigli: true,
    children: [
      {
        id: 'magazzino',
        title: 'Gestione Dispositivi Medici',
        type: 'item',
        icon: 'local_shipping',
        url: '/magazzino',
        visibile: true,
        trackerIndex: NAVIGAZIONE.UDI,
        queryParams: { t: 1 }
      },
      {
        id: 'dvr',
        title: 'DVR',
        type: 'item',
        icon: 'fiber_dvr',
        url: '/dvr',
        trackerIndex: NAVIGAZIONE.DVR,
        visibile: true
      },
      {
        id: 'centri_di_costo',
        title: 'Centri di costo',
        type: 'item',
        icon: 'playlist_add_check',
        url: '/centri-di-costo',
        queryParams: { t: 1 },
        trackerIndex: NAVIGAZIONE.CentriDiCosto,
        visibile: true
      },
      {
        id: 'valore_studio',
        title: 'Calcola valore studio',
        type: 'item',
        icon: 'store',
        url: '/valore-studio',
        trackerIndex: NAVIGAZIONE.CalcolaValoreStudio,
        visibile: true
        // queryParams: { t: 1 }
      },
      {
        id: 'finanza-agevolata',
        title: 'Finanza agevolata',
        type: 'collapsable',
        icon: 'payments',
        visibile: true,
        visibilePerNonSoci: true,
        children: [
          {
            id: 'finanza-agevolata-corso',
            title: 'Corso',
            type: 'item',
            url: '/finanza-agevolata/corso'
          },
          {
            id: 'finanza-agevolata-bandi',
            title: 'Bandi',
            type: 'item',
            url: '/finanza-agevolata/bandi'
          }
        ]
      },
      {
        id: 'prontuario',
        title: 'Prontuario farmaceutico',
        type: 'item',
        icon: 'library_books',
        url: '/prontuario-farmaceutico',

        trackerIndex: NAVIGAZIONE.ProntuarioFarmaceutico,
        visibile: true
      },
      {
        id: 'comunicazioni_paziente',
        title: 'Video comunicazione paziente',
        type: 'item',
        icon: 'video_library',
        url: '/comunicazioni-paziente',
        trackerIndex: NAVIGAZIONE.VideoComunicazionePaziente,
        visibile: true
      }
    ]
  },
  //  {
  //    id: 'ris',
  //    title: 'R.I.S.',
  //    translate: 'NAV.ACADEMY',
  //    type: 'item',
  //    icon: 'book',
  //    url: '/ris',
  //    visibile: true
  //  },
  {
    id: 'pec',
    title: 'PEC',
    type: 'collapsable',
    icon: 'mail',
    filtraFigli: true,
    children: [
      {
        id: 'gotowebmail',
        title: 'Accedi alla PEC',
        type: 'item',
        icon: 'mail',
        url: 'https://webmailpec.andi.it/',
        externalUrl: true,
        openInNewTab: true,
        visibile: true,
        trackerIndex: NAVIGAZIONE.AccediPec
      },
      {
        id: 'attivazione-pec',
        title: 'Richiedi PEC ANDI',
        type: 'item',
        icon: 'mail_outline',
        url: '/attivazione-pec',
        trackerIndex: NAVIGAZIONE.RichiediPEC,
        visibile: true,
        visibilePerNonSoci: false
      }
    ]
  },
  {
    id: 'eventi',
    title: 'Eventi',
    type: 'collapsable',
    icon: 'event',
    filtraFigli: true,
    children: [
      {
        id: 'adesioni',
        title: 'Adesioni',
        type: 'item',
        faicon: 'fa-file-contract',
        icon: '',
        url: '/adesioni',
        trackerIndex: NAVIGAZIONE.Adesioni,
        visibile: true,
        visibilePerFondazione: true
      },
      {
        id: 'compass',
        title: 'Compass',
        type: 'item',
        faicon: 'fa-drafting-compass',
        icon: '',
        url: '/compass',
        trackerIndex: NAVIGAZIONE.Compass,
        visibile: true,
        visibilePerNonSoci: true,
        visibilePerFondazione: false
      },
      {
        id: 'confprofessioni',
        title: 'ConfProfessioni',
        type: 'item',
        icon: '',
        img: 'https://s3-eu-west-1.amazonaws.com/assets.brain.exacloud.it/conf_logo.svg',
        url: '/confprofessioni',
        trackerIndex: NAVIGAZIONE.Confprofessioni,
        visibile: true,
        visibilePerFondazione: true
      },
      // {
      //   id: 'congresso-scientifico-nazionale',
      //   title: 'Congresso Scientifico ANDI',
      //   type: 'item',
      //   icon: 'event',
      //   url: '/congresso-nazionale',
      //   trackerIndex: NAVIGAZIONE.CongressoScientifico,
      //   visibile: true,
      //   visibilePerFondazione: false,
      //   visibilePerNonSoci: true
      // },
      {
        id: 'prescrizione-antibiotica',
        title: 'Questionario prescrizione antibiotica',
        type: 'item',
        icon: 'receipt',
        url: '/prescrizione-antibiotica',
        trackerIndex: NAVIGAZIONE.QuestionarioAntibioticoResistenza,
        visibile: true,
        visibilePerNonSoci: false
      }
    ]
  },
  {
    id: 'editoriale',
    title: 'Editoriale',
    type: 'collapsable',
    icon: 'menu_book',
    filtraFigli: true,
    children: [
      {
        id: 'ris',
        title: 'RIS',
        type: 'item',
        icon: 'book',
        url: '/ris',
        trackerIndex: NAVIGAZIONE.RIS,
        visibile: true,
        visibilePerFondazione: false,
        visibilePerNonSoci: true
      },
      {
        id: 'manuali_andi',
        title: 'Manuali ANDI',
        type: 'item',
        icon: 'font_download',
        url: '/manuali',
        trackerIndex: NAVIGAZIONE.ManualiANDI,
        visibile: true
      }
    ]
  },
  // {
  //   id: 'acquista-mind',
  //   title: 'Acquista MIND',
  //   // translate: "NAV.ACADEMY",
  //   type: 'item',
  //   icon: '',
  //   img: 'assets/icon-mind.png',
  //   url: '/acquista-mind',
  //   visibile: true,
  //   visibilePerNonSoci: true,
  //   visibilePerFondazione: false,
  //   visibilePerSezioni: false
  // },
  {
    id: 'assicurazione-armundia',
    title: 'Assicurazione Oris Broker',
    type: 'item',
    icon: 'assignment_turned_in',
    url: '/assicurazioni',
    trackerIndex: NAVIGAZIONE.Assicurazione,
    visibile: true,
    visibilePerNonSoci: false
  },
  // {
  //   id: 'file_manager',
  //   title: 'Gestione Documenti',
  //   translate: 'NAV.FILE_MANAGER',
  //   type: 'item',
  //   icon: 'folder',
  //   url: '/file-manager',
  //   visibile: true
  // },
  // {
  //   id: 'supporto',
  //   title: 'Supporto',
  //   translate: 'NAV.ACADEMY',
  //   type: 'item',
  //   icon: 'live_help',
  //   url: '/supporto',
  //   visibile: true
  // },
  // {
  //   id: 'lavagna',
  //   title: 'Lavagna',
  //   translate: 'NAV.ACADEMY',
  //   type: 'item',
  //   icon: 'developer_board',
  //   url: '/lavagna',
  //   visibile: true
  // },
  {
    id: 'impostazioni',
    title: 'Impostazioni',
    type: 'item',
    icon: 'settings',
    url: '/impostazioni',
    queryParams: { t: 1 },
    trackerIndex: NAVIGAZIONE.Impostazioni,
    visibile: true,
    visibilePerNonSoci: true,
    visibilePerFondazione: true
  },
  {
    id: 'assistenza',
    title: 'Assistenza',
    type: 'item',
    icon: 'assessment',
    url: '/supporto',
    trackerIndex: NAVIGAZIONE.Assistenza,
    visibile: true,
    visibilePerNonSoci: true,
    visibilePerFondazione: true
  }
];
